var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value != 0)?_c('div',{staticClass:"bo-point"},[_c('i',{staticClass:"icon-bpoint"}),_vm._v("\n    +"+_vm._s(_vm.roundToDecimal(_vm.value))+" "+_vm._s(_vm.generalTranslations.points ?? 'PTS')+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }